import { createStyles, makeStyles } from '@zn-material-ui'

const useStyles = makeStyles(() =>
  createStyles({
    postionLeft: {
      width: 302,
      top: -140,
      position: 'relative',
    },
    postionRight: {
      width: 302,
      top: -200,
      marginLeft: 158,
      boxSizing: 'border-box',
      position: 'relative',
    },
    wrapper: {
      width: 460,
      height: 52,
      marginTop: 20,
      position: 'relative',
      '@global': {
        '.geetest_holder': {
          height: '52px !important',
          width: '460px !important',
          background: '#FFFFFF',
          borderRadius: '2px',
        },
        '.geetest_radar_btn': {
          backgroundImage: 'unset !important',
          border: '1px solid #4E8FFF !important',
          '&:hover': {
            backgroundImage: 'unset !important',
          },
        },
        '.geetest_radar': {
          display: 'none !important',
        },
        '.geetest_wait': {
          top: '50% !important',
          transform: 'translateY(-50%) !important',
          marginTop: '0px !important',
          marginBottom: '0px !important',
        },
        '.geetest_radar_tip_content, .geetest_success_radar_tip_content': {
          fontSize: 18,
          position: 'absolute',
          left: '50% !important',
          transform: 'translateX(-50%) !important',
          color: '#4E8FFF',
        },
        '.geetest_success_radar_tip_content': {
          color: '#52C41A',
        },
        '.geetest_success_img': {
          left: '50% !important',
          top: '50% !important',
          transform:
            'translateX(-50%) translateX(-55px) translateY(-50%) !important',
        },
        '.geetest_radar_tip, .geetest_success_radar_tip': {
          top: '50% !important',
          transform: 'translateY(-50%) !important',
        },
      },
    },
    loading: {
      width: '20px !important',
      height: '20px !important',
      position: 'absolute',
      left: '50%',
      marginLeft: '-10px',
    },
  })
)

export default useStyles
